module.exports = __webpack_public_path__ + "static/scale-model-of-atlanta-history-center-in-sandy-springs-georgia-9a0fe58c90f99c666f78cae4a028e524.png";